import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { send_request } from '../../../utils/Request';
import ConfirmDestructiveActionDialog from '../../W86Components/ConfirmDestructiveActionDialog';

function ConfirmTerminateSessionDialog({ isOpen, close, sessionId, terminateSession }) {
  const [user, setUser] = useState(null);
  const [isTerminating, setIsTerminating] = useState(false);

  useEffect(() => {
    const loadUsername = async () => {
      const json = await send_request(`authz-service/user-info`, '', {});
      if (json && json.data) setUser(json.data.displayName);
    };
    loadUsername();
  }, []);

  return (
    <ConfirmDestructiveActionDialog
      open={isOpen}
      title="Confirm terminate entire session"
      headerDetail={
        <>
          <strong>{user || <Skeleton variant="text" width={125} sx={{ display: 'inline-block' }} />}</strong>{' '}
          is terminating this session
        </>
      }
      warning="You are about to terminate this entire session. This will terminate and stop all components within it from running further."
      confirmPhrase="terminate"
      confirmLabel="Terminate"
      loading={isTerminating}
      manageLoading={false}
      onClose={close}
      onConfirm={async () => {
        setIsTerminating(true);
        try {
          await terminateSession(sessionId);
          close();
        } finally {
          setIsTerminating(false);
        }
      }}
    />
  );
}

export default ConfirmTerminateSessionDialog;
